import React, { useState, useRef } from "react";
import { EmailSubscribeEvent } from "../../utils/gtm";
const SubscribeBox = () => {
  const [details, setDetails] = useState("Subscribe");
  const [phone, setPhone] = useState({
    number: "",
    format: "",
    iso2: "",
    dialCode: "",
  });
  const [error, setError] = useState({
    email: "",
    phone: "",
  });

  const emailSubscribeBtn = useRef(null);

  const phoneValidateRegex = /^[\d+\-\(\) ]+$/;

  const subscribeBoxUser = async (userData) => {
    try {
      const url = `https://userstream.swarajyamag.com/api/subscribe-boxes`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer 9756c92fe386223d61e52f938896b91131ec1234b8fd8892d2e0d1ed574772529413148d9392519664ae1e4661c61b87a0dbd725249a4131e8c0382fa297b56ab3916c0069a48cd7d9f60ac80e2a99733a4204ba0a2867c949e450c39b2d6f7d386bf01611112a010c17d4e14a6b833cf1ee65fd5460bd08525e5f1ab005702a`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
        cache: "no-store",
      });
      const data = await res.json();
      if (data.error?.status !== 400) {
        throw new Error(`Could not subscribe for email --> ${userData.data.email}: ${data.error.message}`);
      }
      return data;
    } catch (error) {
      console.error(`Error in subscribeBoxUser`, error.message);
    }
  };

  const addToListMonk = async (email) => {
    try {
      let url = `https://web-production-05d1.up.railway.app/emailsubscribe`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, source: "website_subscription_box" }),
      });
      if (!res.ok) {
        logger(url, res.statusText, res.status, "POST", {
          message: `Could not add email to list: ${res.statusText}`,
        });
        throw new Error(`Could not add email to list: ${res.statusText}`);
      }
      const data = await res.json();
      return data;
    } catch (e) {
      console.error(e.message);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevents page refresh
    emailSubscribeBtn.current.disabled = true; // Disable the submit button

    const formData = new FormData(event.target);
    const email = formData.get("email");
    const phoneNumber = formData.get("phone");

    const emailValidateRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!emailValidateRegex.test(email.toLowerCase())) {
      setError({ email: "Invalid email address", phone: "" });
      emailSubscribeBtn.current.disabled = false;
      return;
    }

    if (!phoneValidateRegex.test(phoneNumber)) {
      setError({ email: "", phone: "Invalid phone number" });
      emailSubscribeBtn.current.disabled = false;
      return;
    }

    setError({ email: "", phone: "" });
    setDetails("Thanks for subscribing!");

    await addToListMonk(email.toLowerCase());
    await subscribeBoxUser({ data: { email: email.toLowerCase(), phoneNo: phoneNumber } });
    if (data.status === 200) {
      if (data.new) {
        EmailSubscribeEvent();
      }
    }
    emailSubscribeBtn.current.disabled = false; // Re-enable the submit button
  };

  return (
    <div className="flex bg-[#f1f0ef] px-5 py-4 dark:bg-zinc-800">
      <div className="flex w-[100%] flex-col gap-4">
        <div className="w-[75%]">
          <h2 className="text-2xl font-bold text-[#ca4242]">Get Swarajya in your inbox.</h2>
          <hr className="mt-1 h-[4px] w-[25%] border-none bg-primary" />
        </div>
        <div className="flex w-full flex-col gap-4">
          <form onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
            <div>
              <input
                name="email"
                id="email"
                type="email"
                required
                className="w-full rounded-sm border-gray-200 px-3 py-2 font-satoshi text-sm dark:border-gray-700 dark:bg-slate-900 dark:text-gray-400"
                placeholder="Email Address"
                onChange={() => setError({ ...error, email: "" })}
              />
              {error.email && <p className="mt-1 text-xs text-red-500">{error.email}</p>}
            </div>

            <div>
              <input
                name="phone"
                id="phone"
                type="text"
                required
                className="w-full rounded-sm border-gray-200 px-3 py-2 font-satoshi text-sm dark:border-gray-700 dark:bg-slate-900 dark:text-gray-400"
                placeholder="Phone Number"
                onChange={() => setError({ ...error, phone: "" })}
              />
              {error.phone && <p className="mt-1 text-xs text-red-500">{error.phone}</p>}
            </div>

            <button
              ref={emailSubscribeBtn}
              type="submit"
              className="rounded-sm border border-transparent bg-primary px-3 py-2 font-satoshi text-sm text-white transition-all focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            >
              {details}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubscribeBox;
